import { AutocompleteInput, Link, required, useGetList, useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";
import { NumberRangeReadModel } from "../../GeneratedClients/FreeBillApi";

const NumberRangeInput = () => {

  const { setValue, getValues } = useFormContext()
  const translate = useTranslate()
  const { data: numberRanges, isLoading: numberRangesLoading} = useGetList(
    'numberRanges', 
    {sort: {field: "name", order: "ASC"}, pagination: {page: 1, perPage: 50}}
  )

  const handleSelect = (id: string) => {
    const numberRange = numberRanges?.find(x => x.id === id)
    setValue('numberRangeId', numberRange?.id)
  }

  const getDefaultNumberRangeId = (numberRanges?: NumberRangeReadModel[]) => {
    return numberRanges?.find(x => x.isDefault)?.id
  }

  var isDraft = window.location.href.includes("drafts")

  const validateNotFound = () => {
    var currentNumberRangeId = getValues("numberRangeId")
    var notFound = !numberRanges?.map(x => x.id).includes(currentNumberRangeId)
    if(notFound)
      return "Pflichtfeld"
    return undefined
  }

  if(numberRangesLoading) return null

  return (
    <AutocompleteInput 
      fullWidth
      helperText={
        <Link 
          to={'/numberRanges/create'} 
        >
          {translate('ra.action.create')}
        </Link>
      }
      validate={[required(), validateNotFound]}
      source="numberRangeId"
      defaultValue={getDefaultNumberRangeId(numberRanges)}
      optionText="name"
      optionValue="id"
      onChange={handleSelect}
      choices={numberRanges}
      label="resources.invoices.numberRange"
      hidden={numberRanges?.length === 1 && !isDraft && getDefaultNumberRangeId(numberRanges) !== undefined}
    />
  )
}

export default NumberRangeInput
